<template>
  <div class="nursingCareFacility" @click="onCardSelected(map)" :class="mapSelectedMarkerId == mapId ? 'selected' : ''">
    <div class="nursingCareFacility__name">{{careHomeName}}</div>
    <div class="nursingCareFacility__detail">
      <img class="facilityImage"
      :src="map.care_home_image.url" v-if="map.care_home_image.url != null">
      <img class="facilityImage"
        src="../../../assets/images/senior_home_image.png" v-else-if="map.care_home_image.url == null && map.care_home_image.default_image_type == 'senior_home'">
      <img class="facilityImage"
        src="../../../assets/images/sakoju_image.png" v-else-if="map.care_home_image.url == null && map.care_home_image.default_image_type == 'sakoju'">
      <img class="facilityImage"
        src="../../../assets/images/image_sonaeru.jpeg" v-else-if="map.care_home_image.url == null && map.care_home_image.default_image_type == 'others'">
      <div class="facilityAddress">
        <div class="addressDescription">
          <div>住所: </div>
          <div>{{mapFullAddress}}</div>
        </div>
        <div class="addressDescription">
          <div>交通: </div>
          <div>{{mapHowToAccess}}</div>
        </div>
        <a :href="detailPageUrl" target='_blank'>詳細を見る</a>
      </div>
    </div>
    <div class="nursingCareFacility__footer">
      <button data-bs-toggle="modal" data-bs-target="#CallOverlay">相談員に相談</button>
      <button data-bs-toggle="modal" data-bs-target="#donwload_overlay" v-if="map.has_pamphlet" style='margin-left: 15px;'>資料入手</button>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'NursingCareFacility',
    props: ['map'],
    components: {},
    data() {
      return {
      }
    },
    computed: {
      ...mapGetters('map', ['mapSelectedMarkerId']),
      mapId(){
        return this.map == null ? null :this.map.id
      },
      mapFullAddress(){
        return (this.map == null || this.map.full_address == null || this.map.address == '') ? 'お問合せ下さい' :this.map.full_address
      },
      mapHowToAccess(){
        return (this.map == null || this.map.how_to_access == null || this.map.how_to_access == '') ? 'お問合せ下さい' :this.map.how_to_access
      },
      careHomeName(){
        return this.map == null ? null :this.map.name
      },
      detailPageUrl(){
        return this.map == null ? '' : `/map/care_homes/${this.map.id}`
      }
    },
    methods: {
      onCardSelected(map){
        this.$emit('onCardSelected', map)
      }
    },
  }
</script>

<style scoped>
.selected {
  border: 3px solid #1F8F5F;
}
</style>
